import "slick-carousel/slick/slick";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import howToSignBlock from "@/modules/how-to-sign/index";
import Accordion from "@/modules/containers/accordion";
import reviewSlider from "@/modules/section-review/index";
import video from "@/modules/video/video";
import { handleFullscreenHelpers } from "@/modules/accessability-exp-10743/video/video";
import modalShow from "@/modules/containers/modal/modal";
import contactForm from "@/modules/blocks/contact-form/index";
import Parallax from "parallax-js";
import ctaDarkBlue from "@/sections/cta/cta-dark-blue/index";
import { animationData } from "@/scripts/animation-data/animatedSignatureLight";
import { clampTextHandler } from "@/scripts/helpers/library";

const animateFormClass = ".js-ready-animate-form";

const reviewSliderSecondary = () => {
  const slickElement = $(".js-review-slider-viewport"),
    nextArrow = $(".js-slider-arrow .btn-next-arrow"),
    prevArrow = $(".js-slider-arrow .btn-prev-arrow"),
    sliderSingle = $(".js-review-slider-viewport");

  slickElement.on("init reInit afterChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1,
      sumCouner = slick.$dots[0].children.length;

    if (counter === 1) {
      prevArrow.addClass("is-disable");
      prevArrow.attr("tabindex", "-1");
    } else if (counter === sumCouner) {
      nextArrow.addClass("is-disable");
      nextArrow.attr("tabindex", "-1");
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    } else {
      nextArrow.removeClass("is-disable");
      nextArrow.removeAttr("tabindex", "-1");
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    }
  });

  slickElement.slick({
    infinite: false,
    slidesToShow: 1,
    speed: 600,
    arrows: false,
    accessibility: true,
    ariaPolite: true,
    adaptiveHeight: true,
    swipeToSlide: false,
    swipe: false,
    dsf: false,
    fade: true,
    dots: true,
    responsive: [
      {
        breakpoint: 959,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          centerMode: false
        }
      }
    ]
  });

  slickElement.on("afterChange", function() {
    $(".slick-list").removeClass("is-open");
  });

  $(".slick-list").attr("aria-live", "polite");

  nextArrow.click(function(e) {
    sliderSingle.slick("slickNext");
  });
  prevArrow.click(function(e) {
    sliderSingle.slick("slickPrev");
  });
};

const startAnimation = () => {
  const animateForm = document.querySelector(animateFormClass);

  if (animateForm !== null) {
    $(".form-wrapper").addClass("animate-form-visible");
  }
};

const initParallaxDecorations = scene => {
  const parallaxInstance = new Parallax(scene[0], {
    pointerEvents: false,
    invertX: false,
    invertY: false,
    relativeInput: false
  });

  parallaxInstance.friction(0.2, 0.2);
};

const initParallaxMobile = () => {
  const tabletBreakpoint = 639;
  if ($(window).width() > tabletBreakpoint) {
    const scene = $(".js-decorations-key-group");
    $(scene).each(function() {
      initParallaxDecorations($(this));
    });
  }
};

const linkShowText = () => {
  let showChar = 148,
    ellipsesText = "",
    moreText = "Show more",
    lessText = "Read less";

  $(".js-message-more").each(function() {
    let contentCollapseText = $(this).html();
    if (contentCollapseText.length > showChar) {
      let showText = contentCollapseText.substr(0, showChar),
        hideText = contentCollapseText.substr(
          showChar,
          contentCollapseText.length - showChar
        ),
        html =
          showText +
          ellipsesText +
          '</span><span class="more-content"><span>' +
          hideText +
          '</span><a class="link-show-text">' +
          moreText +
          "</a></span>";

      $(this).html(html);
    }
  });

  $(".link-show-text").click(function() {
    if ($(this).hasClass("less")) {
      $(this).removeClass("less");
      $(this).html(moreText);
    } else {
      $(this).addClass("less");
      $(this).html(lessText);
    }
    $(this)
      .parent()
      .prev()
      .toggle();
    $(this)
      .prev()
      .toggle();
    return false;
  });
};

$(document).ready(function() {
  addedLazyLoadImages();
  initWowLibrary();
  reviewSliderSecondary();
  howToSignBlock();
  Accordion();
  reviewSlider();
  video();
  startAnimation();
  modalShow();
  contactForm();
  initParallaxMobile();
  linkShowText();
  ctaDarkBlue(animationData);
  clampTextHandler(45, ".pages-links-list__link");

  $(window).on("resize", function() {
    handleFullscreenHelpers();
  });

  $("[data-micromodal-trigger]").click(function(e) {
    e.preventDefault();
  });
});
